import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

export const mainListItems = [
  { label: 'Dashboard', path: '/dashboard', icon: DashboardOutlinedIcon },
  { label: 'Stammdaten', path: '/stammdaten', icon: PersonOutlineIcon },
  { label: 'Bestellung', path: '/bestellung', icon: ShoppingCartOutlinedIcon },
  { label: 'Produkte', path: '/produkte', icon: Inventory2OutlinedIcon },
  { label: 'Rechnungen', path: '/rechnungen', icon: ReceiptLongOutlinedIcon },
];
